import { createMap, forMember, mapFrom, constructUsing } from "@automapper/core";
import { UserActivitySummaryViewModelKeysTypeName, UserActivitySummaryQueryFieldsTypeName } from "./constants.js";
import { UserActivitySummaryServiceModel } from "./service.js";
import { UserActivitySummaryViewModel } from "./types.js";
class UserActivitySummaryMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      UserActivitySummaryServiceModel,
      UserActivitySummaryViewModel,
      forMember(
        (vm) => vm.uid,
        mapFrom((m) => m?.uid)
      ),
      forMember(
        (vm) => vm.average_bet,
        mapFrom((m) => m?.average_bet)
      ),
      forMember(
        (vm) => vm.average_poker_buy_in,
        mapFrom((m) => m?.average_poker_buy_in)
      ),
      forMember(
        (vm) => vm.casino_favorite_games,
        mapFrom((m) => m?.casino_favorite_games)
      ),
      forMember(
        (vm) => vm.days_from_last_active,
        mapFrom((m) => m?.days_from_last_active)
      ),
      forMember(
        (vm) => vm.last_played_game,
        mapFrom((m) => m?.last_played_game)
      ),
      forMember(
        (vm) => vm.poker_favorite_games,
        mapFrom((m) => m?.poker_favorite_games)
      ),
      forMember(
        (vm) => vm.skill_flag,
        mapFrom((m) => m?.skill_flag)
      ),
      forMember(
        (vm) => vm.slot_favorite_games,
        mapFrom((m) => m?.slot_favorite_games)
      )
    );
    createMap(
      mapper,
      UserActivitySummaryViewModelKeysTypeName,
      UserActivitySummaryQueryFieldsTypeName,
      constructUsing((m) => {
        const mapper2 = {
          uid: null
        };
        return mapper2[m] === void 0 ? m : mapper2[m];
      })
    );
  }
}
export {
  UserActivitySummaryMapping
};
//# sourceMappingURL=mapper.js.map
